export const noteTypes = [
  { 
    key: "Review", 
    text: "Review", 
    value: "Review" 
  },
  { 
    key: "Recommendation", 
    text: "Recommendation", 
    value: "Recommendation" 
  },
  { 
    key: "Escalation", 
    text: "Escalation", 
    value: "Escalation" 
  },
  { 
    key: "DeEscalation", 
    text: "DeEscalation", 
    value: "DeEscalation" 
  },
  {
    key: "SystematicReopening",
    text: "Systematic Reopening",
    value: "Systematic Reopening",
  },
  {
    key: "Administrative Reopening",
    text: "Administrative Reopening",
    value: "Administrative Reopening",
  },
  { 
    key: "Document", 
    text: "Document", 
    value: "Document" 
  },
  { 
    key: "Description", 
    text: "Description", 
    value: "Description" 
  },
  { 
    key: "General", 
    text: "General", 
    value: "General" 
  },
];
